import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UsioMarkAsProcessedEvent = BaseLoanEvent.extend({
  type: z.literal('usioMarkAsProcessed'),
  paymentId: zodBrandedUuid<PaymentId>(),
});
export type UsioMarkAsProcessedEvent = z.infer<typeof UsioMarkAsProcessedEvent>;
